<template>
  <ul class="BulletsComponent">
    <li
      v-for="(item, i) in items"
      :key="i"
      class="row"
    >
      {{ item }}
    </li>
  </ul>
</template>

<script setup lang="ts">
interface PropsInterface {
  items: any
}
withDefaults(defineProps<PropsInterface>(), {})
</script>

<style lang="scss" scoped>
.BulletsComponent {
  padding-left: $spacing-3xl;

  .row {
    padding: $spacing-xs;
    color: $color-neutral;

    &::marker {
      color: $color-primary-light;
    }
  }
}
</style>
